import { GenericHoldScreen } from '../GenericHoldScreen'
import TabNavigator from '../TabNavigator'

const BulkActionTabScreen = () => {
  return (
    <TabNavigator
      title={'F&R Actions'}
      tabs={[
        {
          name: 'riskHoldable',
          component: GenericHoldScreen,
          title: 'Yet To Be Settled',
          initialParams: {
            type: 'PAYOUT_STAGED',
          },
        },
        {
          name: 'riskHold',
          component: GenericHoldScreen,
          title: 'Risk Hold',
          initialParams: {
            type: 'RISK_HOLD',
          },
        },
        {
          name: 'limitHold',
          component: GenericHoldScreen,
          title: 'Limit Hold',
          initialParams: {
            type: 'LIMIT_HOLD',
          },
        },
      ]}
    />
  )
}

export default BulkActionTabScreen
